/**
 * Компонент SkeletonLoader
 * Skeleton screens для состояний загрузки в стиле Aura.build
 * Автор: AI Market Hub
 */

import { motion } from 'framer-motion';

export default function SkeletonLoader({ 
  type = 'default',
  count = 1,
  className = '',
  ...props 
}) {
  const skeletons = Array.from({ length: count });

  // Типы скелетонов
  const types = {
    default: (
      <div className="space-y-3">
        <div className="h-4 bg-white/10 rounded-lg animate-pulse" />
        <div className="h-4 bg-white/10 rounded-lg animate-pulse w-3/4" />
      </div>
    ),
    'video-card': (
      <div className="p-6 bg-white/5 rounded-2xl border border-white/10 space-y-4">
        <div className="h-6 bg-white/10 rounded-lg animate-pulse w-2/3" />
        <div className="h-4 bg-white/10 rounded-lg animate-pulse" />
        <div className="h-4 bg-white/10 rounded-lg animate-pulse w-4/5" />
        <div className="flex gap-2 mt-4">
          <div className="h-8 bg-white/10 rounded-lg animate-pulse w-24" />
          <div className="h-8 bg-white/10 rounded-lg animate-pulse w-24" />
        </div>
      </div>
    ),
    'stat-card': (
      <div className="p-6 bg-gradient-to-br from-purple-600/20 to-pink-600/20 rounded-2xl border border-white/10">
        <div className="h-8 w-8 bg-white/20 rounded-lg animate-pulse mb-4" />
        <div className="h-8 bg-white/20 rounded-lg animate-pulse w-20 mb-2" />
        <div className="h-4 bg-white/20 rounded-lg animate-pulse w-32" />
      </div>
    ),
    'form-input': (
      <div className="space-y-2">
        <div className="h-4 bg-white/10 rounded w-24 animate-pulse" />
        <div className="h-10 bg-white/10 rounded-xl animate-pulse" />
      </div>
    ),
    'button': (
      <div className="h-12 bg-white/10 rounded-xl animate-pulse w-32" />
    ),
  };

  return (
    <div className={className} {...props}>
      {skeletons.map((_, index) => (
        <motion.div
          key={index}
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: index * 0.1 }}
        >
          {/* Shimmer эффект */}
          <div className="relative overflow-hidden">
            <div className="absolute inset-0 -translate-x-full animate-shimmer bg-gradient-to-r from-transparent via-white/10 to-transparent" />
            {types[type] || types.default}
          </div>
        </motion.div>
      ))}
    </div>
  );
}




